var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group-item',{class:_vm.classObject,attrs:{"button":""},on:{"click":function($event){return _vm.onClickSideBarItem(_vm.to)}}},[_c('div',{staticStyle:{"width":"30px"}},[(_vm.icon)?_c('font-awesome-icon',{staticClass:"st-sidebaricon",attrs:{"icon":_vm.icon,"size":"sm"}}):_vm._e()],1),_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }